import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StudentDashboard from './StudentDashboard';
import InstructorDashboard from './InstructorDashboard';
//import { getUserRole } from './api'; // No longer needed

const Dashboard = ({ user }) => {
    //const [userRole, setUserRole] = useState('student'); // No longer needed, use user.role directly
    const navigate = useNavigate();

    /*  // No longer needed
    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                const role = await getUserRole(user.email);
                setUserRole(role);
            } catch (error) {
                console.error('Error fetching user role:', error);
            }
        };

        fetchUserRole();
    }, [user.email]);
    */

    useEffect(() => {
        if (user.role === 'Creator') {
            navigate('/instructor/overview');
        }
    }, [user.role, navigate]);

    return (
        <div className="dashboard-container">
            {user.role !== 'Creator' && <StudentDashboard user={user} />}
            {user.role === 'Creator' && <InstructorDashboard view="overview" user={user} />}
        </div>
    );
};

export default Dashboard;
